//import AOS from 'aos/dist/aos';
//import 'aos/dist/aos.css';
import './vendor/slick.min';
import $ from 'jquery';

import Faq from './blocks/faq/view.js';
import Slideshow from './blocks/slideshow/view.js';
import Tabs from './blocks/tabs/view.js';
import Testimonials from './blocks/testimonials/view.js';
import TextSlider from './blocks/text-slider/view';

docReady( function () {

    /*
    AOS.init( {
        once: true
    } )
    */

    let faq = new Faq();
    faq.init();

    let slideshow = new Slideshow();
    slideshow.init();

    let textSlider = new TextSlider();
    textSlider.init();

    let tabs = new Tabs();
    tabs.init();

    let testimonials = new Testimonials();
    testimonials.init();

    $( '.animation_frame' ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        draggable: true,
        infinite: false,
        vertical: true,
        autoplay: true,
        autoplaySpeed: 500,
        fade: false,
    } );
} )


function docReady ( fn ) {
    if ( document.readyState === "complete" || document.readyState === "interactive" ) {
        setTimeout( fn, 1 );
    } else {
        document.addEventListener( "DOMContentLoaded", fn );
    }
}